module.exports = __webpack_public_path__ + "assets/flags/fr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/fr.svg
// module id = 501
// module chunks = 0